module.exports = __webpack_public_path__ + "static/media/hide.e09474e0.jpg";